import { getCurrency } from './getCurrency';

// FIXME: con la respuesta nueva de pricing, esto no sería necesario
// bah, es necesario hacer la transforación del currency, pero sin recalcular
// nada. sólo usando discount_percentage y discount_nominal que vienen en la
// respuesta nueva
export const getPricingValue = async (currency_id, rulesPricing, precioAuto, currency) => {
    const { multiplier, actualSellValue } = currency_id ? await getCurrency(currency_id) : currency
    const resultCaltulateDescuento = rulesPricing.reduce(getReducePercentageDiscount, 0)
    const resultCaltulateValorNominal = rulesPricing.reduce(getReduceNominalDiscount, 0)
  
    return (resultCaltulateValorNominal / (multiplier * actualSellValue)) + (resultCaltulateDescuento * precioAuto / 100)
}

const getReducePercentageDiscount = (valueTotal, rule) => {
    return rule.unit === "PORCENTAJE" ? valueTotal + rule.value : valueTotal
}

const getReduceNominalDiscount = (valueTotal, rule) => {
    return rule.unit === "PESOS" ? valueTotal + rule.value : valueTotal
}